const milisInDay = 1000 * 60 * 60 * 24;
const NOW_DATE = new Date();

export const getDateBefore = (days: number) => new Date(NOW_DATE.getTime() - days * milisInDay);

export const formatDate = (date: Date): string =>
  date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

export const REPORTING_TIME = 'reportingTime';

export const quantityFilters = [
  { label: 'All quantities', value: '' },
  { label: 'More than 100 ton', value: '100' },
  { label: 'More than 500 ton', value: '500' },
  { label: 'More than 1000 ton', value: '1000' },
];
export const reportingTimeFilters = [
  { label: 'All dates', value: '' },
  { label: 'Since last week', value: getDateBefore(7).toLocaleDateString() },
  { label: 'Since last month', value: getDateBefore(30).toLocaleDateString() },
  { label: 'Last 2 Months', value: getDateBefore(60).toLocaleDateString() },
];

export const getTimeStamp = () => new Date().getDate();
